import { CallbackObject } from 'api/core/get-page-function';
import { AxiosResponse } from 'axios';
import { GetLocationsVm } from './get-locations.vm';
import { plainToClass } from 'class-transformer';
import { instance } from 'api/core';

export const getLocations = async (warehouseId: string, offset: string, callback: CallbackObject<GetLocationsVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  try {
    const res: AxiosResponse = await instance.get(`/warehouse/warehouses/${warehouseId}/locations`, config);
    callback.success(plainToClass(GetLocationsVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
